<template>
  <div id="digital-content-animation" data-tilda-export="yes" class="t-records" data-hook="blocks-collection-content-node" data-tilda-project-id="1933100" data-tilda-page-id="11358254" data-tilda-page-alias="success" data-tilda-formskey="00da022453d7435b7731ad57b717c0d2">
    <div id="rec191508289" class="r t-rec" style="" data-animationappear="off" data-record-type="396">
      <div class="t396">
        <div class="t396__artboard" data-artboard-recid="191508289" data-artboard-height="640" data-artboard-height_vh="100" data-artboard-valign="center" data-artboard-ovrflw="">

          <div class="t396__carrier" data-artboard-recid="191508289"></div>
          <div class="t396__filter" data-artboard-recid="191508289"></div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945669 t-animate" data-elem-id="1589462945669"
            data-elem-type="image" data-field-top-value="143" data-field-top-res-480-value="125" data-field-left-value="3" data-field-left-res-480-value="3" data-field-width-value="426" data-field-width-res-480-value="340" data-field-width-res-320-value="280" data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value="" data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value="" data-animate-style="zoomin" data-animate-duration="1" data-animate-scale="0.9" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3939-6431-4633-b465-663335346633__blob.svg" imgfield="tn_img_1589462945669" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945681 t-animate" data-elem-id="1589462945681"
            data-elem-type="image" data-field-top-value="125" data-field-top-res-960-value="125" data-field-top-res-640-value="60" data-field-top-res-480-value="75" data-field-top-res-320-value="40" data-field-left-value="176" data-field-left-res-960-value="90" data-field-left-res-640-value="30" data-field-left-res-480-value="10" data-field-left-res-320-value="-48" data-field-width-value="144" data-field-width-res-640-value="100" data-field-width-res-480-value="80" data-field-axisy-value="top" data-field-axisx-value="left" data-field-container-value="grid" data-field-topunits-value="" data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value="" data-animate-style="fadeinleft" data-animate-duration="1" data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild6438-6261-4465-a539-616232636230__bubble.svg" imgfield="tn_img_1589462945681" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945688 t-animate" data-elem-id="1589462945688"
            data-elem-type="image" data-field-top-value="40" data-field-top-res-640-value="40" data-field-top-res-480-value="40" data-field-top-res-320-value="35" data-field-left-value="-110" data-field-left-res-640-value="-80" data-field-left-res-480-value="-50" data-field-left-res-320-value="-60" data-field-width-value="100" data-field-width-res-480-value="80" data-field-axisy-value="top" data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value="" data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value="" data-animate-style="fadeindown" data-animate-duration="1" data-animate-delay="0.1" data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3938-3763-4633-a231-633631356162__coluds.svg" imgfield="tn_img_1589462945688" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945694 t-animate" data-elem-id="1589462945694"
            data-elem-type="image" data-field-top-value="235" data-field-top-res-480-value="235"
            data-field-top-res-320-value="41" data-field-left-value="242" data-field-left-res-480-value="201"
            data-field-left-res-320-value="207" data-field-width-value="201" data-field-axisy-value="top"
            data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value=""
            data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value=""
            data-animate-style="fadeinleft" data-animate-duration="1" data-animate-distance="100"
            data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3261-3465-4634-b933-653630363666__gentleman.svg"
                imgfield="tn_img_1589462945694" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945699 t-animate" data-elem-id="1589462945699"
            data-elem-type="image" data-field-top-value="160" data-field-top-res-480-value="160"
            data-field-top-res-320-value="305" data-field-left-value="-220" data-field-left-res-480-value="-210"
            data-field-left-res-320-value="-100" data-field-width-value="200" data-field-axisy-value="top"
            data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value=""
            data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value=""
            data-animate-style="fadeinright" data-animate-duration="1" data-animate-distance="100"
            data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild6135-6239-4632-b539-313561663463__lady.svg" imgfield="tn_img_1589462945699" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945704 t-animate" data-elem-id="1589462945704"
            data-elem-type="image" data-field-top-value="-147" data-field-top-res-960-value="-147"
            data-field-top-res-640-value="-37" data-field-top-res-480-value="198" data-field-top-res-320-value="-102"
            data-field-left-value="-134" data-field-left-res-960-value="6" data-field-left-res-640-value="-214"
            data-field-left-res-480-value="-54" data-field-left-res-320-value="66" data-field-width-value="156"
            data-field-axisy-value="bottom" data-field-axisx-value="right" data-field-container-value="grid"
            data-field-topunits-value="" data-field-leftunits-value="" data-field-heightunits-value=""
            data-field-widthunits-value="" data-animate-style="fadeinup" data-animate-duration="1"
            data-animate-delay="0.3" data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3738-3230-4464-a662-626436643738__rastenie-1.svg"
                imgfield="tn_img_1589462945704" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945707 t-animate" data-elem-id="1589462945707"
            data-elem-type="image" data-field-top-value="-154" data-field-top-res-960-value="-154"
            data-field-top-res-640-value="216" data-field-top-res-480-value="-139" data-field-top-res-320-value="-292"
            data-field-left-value="160" data-field-left-res-960-value="30" data-field-left-res-640-value="0"
            data-field-left-res-480-value="190" data-field-left-res-320-value="-90" data-field-width-value="92"
            data-field-width-res-320-value="120" data-field-axisy-value="bottom" data-field-axisx-value="left"
            data-field-container-value="grid" data-field-topunits-value="" data-field-leftunits-value=""
            data-field-heightunits-value="" data-field-widthunits-value="" data-animate-style="fadeinup"
            data-animate-duration="1" data-animate-delay="0.2" data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild6538-6233-4535-a637-653936346566__rastenie-2.svg"
                imgfield="tn_img_1589462945707" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589462945712 t-animate" data-elem-id="1589462945712"
            data-elem-type="image" data-field-top-value="130" data-field-top-res-960-value="130"
            data-field-top-res-640-value="55" data-field-top-res-480-value="75" data-field-top-res-320-value="40"
            data-field-left-value="-183" data-field-left-res-960-value="-93" data-field-left-res-640-value="-30"
            data-field-left-res-480-value="-10" data-field-left-res-320-value="39" data-field-width-value="137"
            data-field-width-res-640-value="100" data-field-width-res-480-value="80" data-field-axisy-value="top"
            data-field-axisx-value="right" data-field-container-value="grid" data-field-topunits-value=""
            data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value=""
            data-animate-style="fadeinright" data-animate-duration="1" data-animate-distance="100"
            data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3733-3666-4533-b966-656563396533__yt.svg" imgfield="tn_img_1589462945712" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589463276804 t-animate" data-elem-id="1589463276804"
            data-elem-type="image" data-field-top-value="45" data-field-top-res-640-value="50"
            data-field-top-res-480-value="45" data-field-top-res-320-value="60" data-field-left-value="118"
            data-field-left-res-640-value="88" data-field-left-res-480-value="60" data-field-left-res-320-value="70"
            data-field-width-value="75" data-field-width-res-480-value="60" data-field-axisy-value="top"
            data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value=""
            data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value=""
            data-animate-style="fadeindown" data-animate-duration="1" data-animate-delay="0.2"
            data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3938-3763-4633-a231-633631356162__coluds.svg" imgfield="tn_img_1589463276804" />
            </div>
          </div>

          <div class="t396__elem tn-elem tn-elem__1915082891589463283355 t-animate" data-elem-id="1589463283355"
            data-elem-type="image" data-field-top-value="40" data-field-top-res-480-value="40"
            data-field-top-res-320-value="20" data-field-left-value="-5" data-field-left-res-480-value="5"
            data-field-left-res-320-value="5" data-field-width-value="30" data-field-axisy-value="top"
            data-field-axisx-value="center" data-field-container-value="grid" data-field-topunits-value=""
            data-field-leftunits-value="" data-field-heightunits-value="" data-field-widthunits-value=""
            data-animate-style="fadeindown" data-animate-duration="1" data-animate-delay="0.3"
            data-animate-distance="100" data-animate-mobile="y">
            <div class="tn-atom">
              <img class="tn-atom__img t-img" data-original="/images/tilda/digital-content/tild3938-3763-4633-a231-633631356162__coluds.svg" imgfield="tn_img_1589463283355" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import makeTag from '@/lib/utils/dom';

export default {
  name: 'DigitalContentAnimation',
  mounted() {
    const lazyLoad = makeTag('script', '/js/lazyload-1.3.min.js');
    document.body.appendChild(lazyLoad);

    const tildaAnimation = makeTag('script', '/js/tilda-animation-1.0.min.js');
    document.body.appendChild(tildaAnimation);

    const tildaScripts = makeTag('script', '/js/tilda-scripts-2.8.min.js');
    document.body.appendChild(tildaScripts);
  },
};
</script>

<style lang="scss">
  @import "css/tilda-grid-3.0.min.css";
  @import "css/tilda-blocks-2.12.css";
  @import "css/tilda-animation-1.0.min.css";
</style>

<style lang="scss" scoped>
  img {
    max-width: 100% !important;
    max-height: 100% !important;
  }
  #digital-content-animation {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: -70px;
    z-index: -1;
    @media (max-width: 420px) {
      top: 30px;
    }
    @media (max-width: 380px) {
      top: 0px;
    }
    @media (max-width: 320px) {
      top: -40px;
    }
  }
  #rec191508289 .t396__artboard {
    min-height: 640px;
    height: 100vh;
    background-color: #ffffff;
  }

  #rec191508289 .t396__filter {
    min-height: 640px;
    height: 100vh;
  }

  #rec191508289 .t396__carrier {
    min-height: 640px;
    height: 100vh;
    background-position: center center;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 1199px) {
    #rec191508289 .t396__artboard {}

    #rec191508289 .t396__filter {}

    #rec191508289 .t396__carrier {
      background-attachment: scroll;
    }
  }

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {}

  @media screen and (max-width: 479px) {}

  #rec191508289 .tn-elem[data-elem-id="1589461406556"] {
    color: #ffffff;
    text-align: center;
    z-index: 7;
    top: calc(50vh - 320px + 200px);
    left: calc(50% - 120px + 0px);
    width: 240px;
    height: 60px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589461406556"] .tn-atom {
    color: #ffffff;
    font-size: 18px;
    font-family: 'Montserrat', Arial, sans-serif;
    line-height: 1.55;
    font-weight: 500;
    border-width: 1px;
    border-radius: 30px;
    background-color: #7cb342;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  }

  #rec191508289 .tn-elem[data-elem-id="1589461406556"] .tn-atom:hover {
    background-color: #6a963b;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589461406556"] {
      top: calc(50vh - 320px + 160px);
      left: calc(50% - 120px + 0px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589461406556"] {
      top: calc(161px);
      left: calc(50% - 100px + 0px);
      width: 200px;
      height: 50px;
    }

    #rec191508289 .tn-elem[data-elem-id="1589461406556"] .tn-atom {
      font-size: 16px;
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589461857212"] {
    color: #000000;
    text-align: center;
    z-index: 6;
    top: calc(50vh - 320px + 290px);
    left: calc(50% - 100px + 0px);
    width: 200px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589461857212"] .tn-atom {
    color: #000000;
    font-size: 12px;
    font-family: 'Montserrat', Arial, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    opacity: 0.7;
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589461857212"] {
      top: calc(50vh - 320px + 250px);
      left: calc(50% - 100px + 0px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589461857212"] {
      top: calc(230px);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945669"] {
    z-index: 2;
    top: calc(50vh - 320px + 143px);
    left: calc(50% - 213px + 3px);
    width: 426px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945669"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945669"] {
      top: calc(50vh - 320px + 125px);
      left: calc(50% - 170px + 3px);
      width: 340px;
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945669"] {
      width: 280px;
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945681"] {
    z-index: 8;
    top: calc(50vh - 320px + 125px);
    left: calc(50% - 600px + 176px);
    width: 144px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945681"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945681"] {
      top: calc(50vh - 320px + 125px);
      left: calc(50% - 480px + 90px);
    }
  }

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945681"] {
      top: calc(50vh - 320px + 60px);
      left: calc(50% - 320px + 30px);
      width: 100px;
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945681"] {
      top: calc(50vh - 320px + 75px);
      left: calc(50% - 240px + 10px);
      width: 80px;
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945681"] {
      top: calc(40px);
      left: calc(50% - 160px + -48px);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945688"] {
    z-index: 9;
    top: calc(50vh - 320px + 40px);
    left: calc(50% - 50px + -110px);
    width: 100px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945688"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945688"] {
      top: calc(50vh - 320px + 40px);
      left: calc(50% - 50px + -80px);
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945688"] {
      top: calc(50vh - 320px + 40px);
      left: calc(50% - 40px + -50px);
      width: 80px;
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945688"] {
      top: calc(35px);
      left: calc(50% - 40px + -60px);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945694"] {
    z-index: 16;
    top: calc(50vh - 320px + 235px);
    left: calc(50% - 100.5px + 242px);
    width: 201px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945694"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945694"] {
      top: calc(50vh - 320px + 235px);
      left: calc(50% - 100.5px + 201px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945694"] {
      top: calc(41px);
      left: calc(50% - 100.5px + 207px);
    }

    #rec191508289 .tn-elem[data-elem-id="1589462945694"] .tn-atom {
      -webkit-transform: rotate(322deg);
      -moz-transform: rotate(322deg);
      transform: rotate(322deg);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945699"] {
    z-index: 10;
    top: calc(50vh - 320px + 160px);
    left: calc(50% - 100px + -220px);
    width: 200px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945699"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945699"] {
      top: calc(50vh - 320px + 160px);
      left: calc(50% - 100px + -210px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945699"] {
      top: calc(305px);
      left: calc(50% - 100px + -100px);
    }

    #rec191508289 .tn-elem[data-elem-id="1589462945699"] .tn-atom {
      -webkit-transform: rotate(330deg);
      -moz-transform: rotate(330deg);
      transform: rotate(330deg);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945704"] {
    z-index: 11;
    top: calc(50vh + 320px + -147px);
    left: calc(50% + 600px - 156px + -134px);
    width: 156px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945704"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945704"] {
      top: calc(50vh + 320px + -147px);
      left: calc(50% + 480px - 156px + 6px);
    }
  }

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945704"] {
      top: calc(50vh + 320px + -37px);
      left: calc(50% + 320px - 156px + -214px);
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945704"] {
      top: calc(50vh + 320px + 198px);
      left: calc(50% + 240px - 156px + -54px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945704"] {
      top: calc(640px + -102px);
      left: calc(50% + 160px - 156px + 66px);
    }

    #rec191508289 .tn-elem[data-elem-id="1589462945704"] .tn-atom {
      -webkit-transform: rotate(315deg);
      -moz-transform: rotate(315deg);
      transform: rotate(315deg);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945707"] {
    z-index: 12;
    top: calc(50vh + 320px + -154px);
    left: calc(50% - 600px + 160px);
    width: 92px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945707"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945707"] {
      top: calc(50vh + 320px + -154px);
      left: calc(50% - 480px + 30px);
    }
  }

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945707"] {
      top: calc(50vh + 320px + 216px);
      left: calc(50% - 320px + 0px);
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945707"] {
      top: calc(50vh + 320px + -139px);
      left: calc(50% - 240px + 190px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945707"] {
      top: calc(640px + -292px);
      left: calc(50% - 160px + -90px);
      width: 120px;
    }

    #rec191508289 .tn-elem[data-elem-id="1589462945707"] .tn-atom {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      transform: rotate(90deg);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945712"] {
    z-index: 13;
    top: calc(50vh - 320px + 130px);
    left: calc(50% + 600px - 137px + -183px);
    width: 137px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589462945712"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945712"] {
      top: calc(50vh - 320px + 130px);
      left: calc(50% + 480px - 137px + -93px);
    }
  }

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945712"] {
      top: calc(50vh - 320px + 55px);
      left: calc(50% + 320px - 100px + -30px);
      width: 100px;
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945712"] {
      top: calc(50vh - 320px + 75px);
      left: calc(50% + 240px - 80px + -10px);
      width: 80px;
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589462945712"] {
      top: calc(40px);
      left: calc(50% + 160px - 80px + 39px);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589463276804"] {
    z-index: 14;
    top: calc(50vh - 320px + 45px);
    left: calc(50% - 37.5px + 118px);
    width: 75px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589463276804"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {
    #rec191508289 .tn-elem[data-elem-id="1589463276804"] {
      top: calc(50vh - 320px + 50px);
      left: calc(50% - 37.5px + 88px);
    }
  }

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589463276804"] {
      top: calc(50vh - 320px + 45px);
      left: calc(50% - 30px + 60px);
      width: 60px;
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589463276804"] {
      top: calc(60px);
      left: calc(50% - 30px + 70px);
    }
  }

  #rec191508289 .tn-elem[data-elem-id="1589463283355"] {
    z-index: 15;
    top: calc(50vh - 320px + 40px);
    left: calc(50% - 15px + -5px);
    width: 30px;
  }

  #rec191508289 .tn-elem[data-elem-id="1589463283355"] .tn-atom {
    background-position: center center;
    border-color: transparent;
    border-style: solid;
  }

  @media screen and (max-width: 1199px) {}

  @media screen and (max-width: 959px) {}

  @media screen and (max-width: 639px) {
    #rec191508289 .tn-elem[data-elem-id="1589463283355"] {
      top: calc(50vh - 320px + 40px);
      left: calc(50% - 15px + 5px);
    }
  }

  @media screen and (max-width: 479px) {
    #rec191508289 .tn-elem[data-elem-id="1589463283355"] {
      top: calc(20px);
      left: calc(50% - 15px + 5px);
    }
  }
</style>
